import { applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { enableMock, disableMock } from "async-ops";
import { mdaeWidgetDataUpdaterMiddleware } from "../common_components/mdae-framework";
import { thunk } from 'redux-thunk';

export const sagaMiddleware = createSagaMiddleware();

export default () => {
  const middleware = [];

  window.enableMock = enableMock;
  window.disableMock = disableMock;
  middleware.push(sagaMiddleware);
  middleware.push(thunk);
  middleware.push(mdaeWidgetDataUpdaterMiddleware);
  return applyMiddleware(...middleware);
};
